import { render, staticRenderFns } from "./tabImage.vue?vue&type=template&id=0be5487d&"
import script from "./tabImage.vue?vue&type=script&lang=js&"
export * from "./tabImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be5487d')) {
      api.createRecord('0be5487d', component.options)
    } else {
      api.reload('0be5487d', component.options)
    }
    module.hot.accept("./tabImage.vue?vue&type=template&id=0be5487d&", function () {
      api.rerender('0be5487d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/TabImage/tabImage.vue"
export default component.exports